import React, { useEffect, useState } from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { DocumentTypeEditorLayout } from './DocumentTypeEditorLayout';

const metaOverrideSet = buildFacetDesignOverride();

export function DocumentTypeEditor({
  resource,
  open,
  handleUpdate,
  onClose,
}) {
  const [frResource, setFrResource] = useState(undefined);
  useEffect(() => {
    setFrResource(resource ? fr.resource(resource) : undefined);
  }, [resource]);
  if (!frResource) {
    return null;
  }
  return (
    <MetaResourceRenderer
      resource={frResource}
      layout={DocumentTypeEditorLayout}
      metaOverrideSet={metaOverrideSet}
      LayoutProps={{ onClose, open, handleUpdate }}
    />
  );
}

DocumentTypeEditor.propTypes = {
  resource: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  handleUpdate: PropTypes.func.isRequired,
};
